// Only what the UI renders (§11). The list feeds the table, the provider pickers
// (BillingProvidersAutocomplete, useChannelOptions) and the test-data generator: id, key,
// name, status and the timestamps cover all of them.
export const listBillingProviders = `
   query listBillingProviders($filter: BillingProvidersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listBillingProviders(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              key
              name
              description
              status
              created
              updated
           }
           nextToken
       }
   }
`;

// createdByUser feeds the detail card's Created By (the `person` formatter reads the
// names; email is not shown, so it is not fetched).
export const getBillingProvider = `
   query getBillingProvider($id:ID!) {
       getBillingProvider(id:$id) {
         id
         key
         name
         description
         status
         createdByUser {
           name
           givenName
           familyName
         }
         created
         updated
       }
}`;
